<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      :searchShow="true"
      :searchMenuSpan="4"
      :searchBtnText="''"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>

            <template slot="manage" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.healthManager || '--' }}
        </div>
      </template>

      <template slot="healthAlarmRecord" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.healthAlarmRecord || '--' }}
        </div>
      </template>

      <template slot="riskLevelManage" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.riskLevelManage || '--' }}
        </div>
      </template>

      <template slot="healthRemindManage" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.healthRemindManage || '--' }}
        </div>
      </template>

      <template slot="healthManageAssist" slot-scope="{ row }">
        <div style="white-space: pre-line; word-break: break-all">
          {{ row.healthManageAssist || '--' }}
        </div>
      </template>
<!-- :disabled="!row.group_chat_id" -->
      <template #group_chat_id="{ row, index }">
        <el-button type="text"  @click="toHealthConsult(row, index)">
          <!-- {{ row.group_chat_id ? '开启群聊' : '--' }} -->
           {{ row.healthManager ? '开启群聊' : '未分配管理师' }}
        </el-button>
      </template>

      <template slot-scope="scope" slot="AIConsult">
        <el-button type="text" size="small" @click="toAIHealthConsult(scope.row)">前往咨询</el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getIntelligentManage } from '@/api/health/manage'
import func from '@/util/func'

export default {
  data() {
    return {
      form: {},
      channel: window.localStorage.getItem('channel'),
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      params: {
        channel: window.localStorage.getItem('channel'),
        pcUserId: window.localStorage.getItem('pcUserId')
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: false,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        cellEdit: true, // 启用单元格编辑
        menu: true,
        menuWidth: 200, // 初始宽度
        searchEnter: true,
        menuTitle: '处理与反馈',
        searchMenuSpan: 4,
        column: [
          {
            label: '用户姓名',
            prop: 'name'
          },
          {
            label: '联系方式',
            prop: 'mobile',
            width: 110
          },
          {
            label: 'vip等级',
            prop: 'vip_level',
            type: 'select',
            search: true,
            dicData: [
              { label: '注册用户', value: 0 },
              // { label: "基础会员", value: 1 },
              { label: '体验会员', value: 2 },
              { label: '月度会员', value: 4 },
              { label: '季度会员', value: 5 },
              { label: '全年会员', value: 3 },
              { label: 'vip会员', value: 6 },
              { label: '解读用户', value: 999 }
            ],
            width: 100,
            searchSpan: 4
          },
          {
            label: '健管责任护士',
            prop: 'manage'
          },
          {
            label: '健康报警跟踪',
            prop: 'healthAlarmRecord',
            formatter: row => {
              return row.healthAlarmRecord || '--'
            },
            minWidth: 120
          },
          {
            label: '风险管理级别',
            prop: 'riskLevelManage',
            formatter: row => {
              return row.riskLevelManage || '--'
            },
            minWidth: 110
          },
          {
            label: '健康提醒管理',
            prop: 'healthRemindManage',
            formatter: row => {
              return row.healthRemindManage || '--'
            }
          },
          {
            label: '健康管理辅助',
            prop: 'healthManageAssist',
            formatter: row => {
              return row.healthManageAssist || '--'
            }
          },
          {
            label: '认知行为治疗'
          },
          {
            label: '免打扰',
            prop: 'notDistrub',
            dicData: [
              { label: '--', value: '0' },
              { label: '已开启', value: '1' }
            ]
          },
          {
            label: '健康管理任务'
          },
          {
            label: '健管沟通内容'
          },
          {
            label: '健康咨询',
            prop: 'group_chat_id',
            formatter: row => {
              return row.group_chat_id ? '开启咨询' : '--'
            }
          },
          {
            label: '人工智能辅助',
            prop: 'AIConsult'
          }
        ]
      },
      data: []
    }
  },
  computed: {},
  methods: {
    onLoad(page, params) {
      params.channel = this.channel

      const param = {
        channal: this.channel,
        page: this.page.currentPage,
        pageSize: this.page.pageSize,
        channel: window.localStorage.getItem('channel'),
        pcUserId: window.localStorage.getItem('pcUserId')
      }

      console.log('param', param)
      getIntelligentManage(param).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377' && res.data.waitTask.length > 0) {
          res.data.waitTask.forEach(item => {
              item.mobile = func.maskPhone(item.mobile);
              item.name = func.maskName(item.name);
          });
        }
        this.page.total = res.data.total
        this.data = res.data.waitTask
        console.log('res.data.total', res.data.total)
      })
    },

    toHealthConsult(row, index) {
      console.log(row.healthManager)
      if (!row.healthManager) {
        this.$message.error('用户无健康咨询')
        return
      }
      const param = {
        chatId: row.group_chat_id,
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/healthmanagement/healthConsult',
        query: param
      })
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem('channel'),
        pcUserId: window.localStorage.getItem('pcUserId')
      }
      this.onLoad(this.page, this.params)
    },

    searchChange(params, done) {
      params.channel = window.localStorage.getItem('channel')
      params.pcUserId = window.localStorage.getItem('pcUserId')
      this.params = params
      this.page.currentPage = 1
      console.log(params)
      this.onLoad(this.page, params)
      done()
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    },

     toAIHealthConsult(row) {
      console.log('test row', row)
      const parameter = {
        wxUserId: row.wx_user_id
      }
      this.$router.push({
        path: '/doctor/AIManage',
        query: parameter
      })
    }
  }
}
</script>

<style scoped>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}
</style>
